import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import {
  ApiResponse,
  ApiErrorResponse,
  IRoute,
  IDepartment,
} from "../utils/types";

const useGetSidebarRoutes = (): UseQueryResult<
  IRoute[] | undefined,
  ApiErrorResponse
> => {
  return useQuery({
    queryKey: ["sidebar-items"],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get<
        ApiResponse<{ departmentsData: IDepartment[] }>
      >(`/getAllDepartments`);

      const departments = response.data?.result.data.departmentsData;
      const adminDepartment = departments.find(
        (item) => item.departmentName === "admin"
      );

      return adminDepartment?.routes;
    },
  });
};

export default useGetSidebarRoutes;
